import '@fontsource/onest/latin-400.css';
import '@fontsource/onest/latin-700.css';
import '@fontsource/onest/latin-800.css';
import "./src/normalize.css";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./src/style.scss";
import "./src/cookie-consent.css";
import 'katex/dist/katex.min.css';

// --- import your browser logger ---
import logtail from "./src/utils/logtail-browser";
import { trackPageView } from "./src/utils/analytics-consent";

export const disableCorePrefetching = () => true;

// global error handlers
window.onerror = (message, source, lineno, colno, error) => {
  logtail.error("Global JS error", {
    message,
    source,
    lineno,
    colno,
    url: window.location.href,
    userAgent: navigator.userAgent,
    error: error?.stack || error,
  });
};

window.onunhandledrejection = (event) => {
  logtail.error("Unhandled promise rejection", { reason: event.reason });
};

export const onRouteUpdate = () => {
  if (process.env.NODE_ENV === "production") trackPageView();
};
